export default {
  client: [],
  sub_client: [],
  sub_user: [],
  responsible_branch: "",
  government: "",
  error_msg: "",
  total_supplied_balance: "",
  next_supply: "",
  success_api: "",
  total_balance: "",
  user: [],
  api_errors: [],
  updated_info: [],
  stox_customer_id: null,
  have_stock: null,
  accept_20_plus_5_dinar: null,
  client_locations: [],
  is_main_client: true,
};
